import { TabValues } from "../deliveryModalUtils/const-enums-types";
/**
 * This function determines if the selected address is a new selection or not.
 * @param newAddressData
 * @param initTabProps
 * @param setNewAddressSelected
 */
export const updateSelectedState = (newAddressData, initTabProps, setNewAddressSelected) => {
    if (!newAddressData) {
        setNewAddressSelected(false); // No new address data, no selection made
        return;
    }
    const isInitialPickup = initTabProps.initTabValue === TabValues.PICKUP;
    const isInitialDelivery = initTabProps.initTabValue === TabValues.DELIVERY;
    const isNewPickupLocation = !!newAddressData.location_sku;
    const isNewDeliveryLocation = !!newAddressData.address_id;
    // A selection must carry an address or pickup-location identity. Kept as a
    // runtime guard because this is what broke in MT-7300, and there is no unit-test
    // runner here. See PaymentDetailsType doc.
    if (!isNewPickupLocation && !isNewDeliveryLocation) {
        setNewAddressSelected(false); // No address identity, so nothing is selected
        return;
    }
    if ((isNewPickupLocation && isInitialDelivery) || (isNewDeliveryLocation && isInitialPickup)) {
        setNewAddressSelected(true); // New selection made from pickup to delivery or vice versa
        return;
    }
    // Check if the initial values and new values match.
    // Guard against undefined === undefined returning true when both sides are absent.
    const initLocationOrDeliveryMatch = (initTabProps.initPickupLocation !== undefined && initTabProps.initPickupLocation === newAddressData.location_sku) ||
        (initTabProps.initDeliveryLocation !== undefined && Number(initTabProps.initDeliveryLocation) === Number(newAddressData.address_id));
    if (initLocationOrDeliveryMatch) {
        setNewAddressSelected(false); // Initial and new values match, no new selection made
        return;
    }
    // No match found, new selection made
    setNewAddressSelected(true);
};
